<template>
  <div class="modal" v-bind:class="{ 'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ CONSTANTS.getCopy('UPLOADANSWERFILE_UPLOAD_NEW_FILE') }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body answer-file">
        <input type="text" :class="{'input-error': showErrors && !payload}"
               v-bind:placeholder="CONSTANTS.getCopy('UPLOADANSWERFILE_PAYLOAD_FILE_PLACEHOLDER') " v-model="payload" />
        <div>
          <div class="is-flex-row-center file" :class="{'input-error': showErrors && !file}">
            <label for="file">
              <span class="icon"><i class="fas fa-file-alt"></i></span>
              <span v-if="!fileName" class="legend">{{ CONSTANTS.getCopy('UPLOADANSWERFILE_SELECT_FILE') }}</span>
              <span v-else class="legend">{{ fileName }}</span>
            </label>
            <input type="file" ref="file" name="resume" id="file" accept="*" @change="setFile" />
          </div>
        </div>
        <div class="field confirm-footer is-grouped-right">
          <div class="button is-primary" @click="saveFile">{{ CONSTANTS.getCopy('UPLOADANSWERFILE_SAVE_FILE') }}</div>
        </div>
      </section>
    </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      showModal: false,
      fileName: null,
      file: null,
      payload: null,
      showErrors: false
    }
  },
  created () {
    Event.$on('showUploadAnswerFile', () => {
      this.showModal = true
    })
  },
  computed: {
    isModalActive () {
      return this.showModal
    }
  },
  methods: {
    close () {
      this.showModal = !this.showModal
      Event.$emit('closeUploadAnswerFile', false)
    },
    accept () {
      this.showModal = false
      Event.$emit('closeUploadAnswerFile', true)
    },
    setFile () {
      let files = this.$refs.file.files

      if (!files.length) {
        this.fileName = null
        return
      }

      this.file = files[0]
      this.fileName = this.file.name
    },
    checkFields () {
      this.showErrors = true
      return (this.file && this.payload)
    },
    saveFile () {
      if (this.checkFields()) {
        let spaceRegExp = /\s/gi
        this.payload = this.payload.replace(spaceRegExp, '_')
        this.api['multipart']('/ResponseRegisterFilePayload', { idClient: this.$route.params.client, payload: this.payload, file: this.file }).then(() => {
          this.accept()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/UploadAnswerFile.vue